import moment from "moment/moment";

export const getDernierJourDeLannee = (date: Date): Date => {
  return moment(date).endOf("year").toDate();
};

export const dateFormatStandard = (date: Date): string => {
  return moment(date).format("DD/MM/YYYY");
};
